module.exports = __webpack_public_path__ + "static/media/favicon-neoventure1012.c7e52600.ico";